import { ConvertObjectCamelToSnakeCase } from "@/app/infrastructures/misc/Utils";
import { QueryParamsEntities } from '@/domain/entities/MainApp';
import { KulionerConfirmOrderInterface } from "@/data/payload/contracts/KulionerConfirmOrderRequest";

/** Kulioner List Api Request Entity */ 
export class KulionerListRequest {
  /** 
   * merchant_code
   * `required`
   * cannot be null
   * cannot be empty string
   * */
  merchantCode = "";

  /**
   * status
   * its only can be assign with these status: `ORDWTC`, `ORDPRC`, `ORDBKD`, `ORDDLV`, `ORDRCV`, `CNCWRF` or empty string
   * ex:
   * - `""`
   * - `ORDWTC`
   * - `ORDWTC,ORDPRC`
   * */
  status = "";

  /**
   * q
   * search keyword
   * */
  q = "";

  /**
   * q_type 
   * desc: type search 
   * validation:
   *  it can only be assign with:
   * - `MERCHANT_NAME`
   * - `MERCHANT_PHONE_NUMBER`
   * - `RECIPIENT_NAME`
   * - `ORDER_ID`
   * - `SHIPMENT_ID`
   * - `STT_NO`
   * */
  qType = "";

  /**
   * start_date
   * ex: 2025-01-01T01:01:01Z
   * */
  startDate = "";

  /**
   * end_date
   * ex: 2025-01-01T01:01:01Z
   * */
  endDate = "";

  /**
   * range_by
   * optional
   * validation: 
   * it can be only assign with `created_at, paid_at`
   * default: `created_at`
   * */
  rangeBy = "created_at";
  page = 1;
  limit = 50;

  constructor(fields?: Partial<KulionerListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString() {
    return new QueryParamsEntities(this).queryString;
  }
}

// kulioner post konfirmasi pesanan
export class KulionerConfirmOrderRequest implements KulionerConfirmOrderInterface {
  // list ko_id dari pesanan
  id: number[] = [];

  constructor(fields?: Partial<KulionerConfirmOrderRequest>) {
    Object.assign(this, fields);
  }

  public toJSON() {
    return JSON.stringify(ConvertObjectCamelToSnakeCase(this));
  }
}
